import { render, staticRenderFns } from "./loadingBroadsignLogo.vue?vue&type=template&id=621c8812&scoped=true"
var script = {}
import style0 from "./loadingBroadsignLogo.vue?vue&type=style&index=0&id=621c8812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c8812",
  null
  
)

export default component.exports